import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { useNavigate, useParams } from 'react-router-dom';

function List() {
    const navigate = useNavigate();

    const { pdc_entity_id } = useParams();

    const pathFrontEnd = '/entityemployees/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}entityemployees/delete`,
        endpoint: config.endpoints.backend + 'entityemployees/getall'
    }

    let list = {
        labelTitle: 'Lista de Empregados',
        labelTitleButtonAdd: 'Importar',
        fieldsShowOnDelete: ['employee_name'],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canAdd: false,
        filter: {
            pdc_entity_id
        },
        columns: [
            {
                name: 'companyid',
                label: 'ID Empresa',
                width: "12%"
            },
            {
                name: 'employeeid',
                label: 'ID Empregado',
                width: "12%"
            },
            {
                name: 'employee_name',
                label: 'Nome do Empregado',
                width: "30%"
            },
            {
                name: 'department',
                label: 'Departamento',
            },
            {
                name: 'entity',
                label: 'Entidade',
            }
        ],
        order: [['employee_name', 'ASC']],
        buttonsListContainer: [
            {
                name: 'entity_employees_goback_entities',
                class: 'btn btn-secondary',
                label: 'Voltar',
                tooltipLabel: 'Voltar',
                callback: async () => {
                    navigate(`/entityemployees/entities`)
                }
            }
        ],
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
